/* ============================================================
   EZINK welcome gift - presentation - assets/ez-gift-ui.js
   ------------------------------------------------------------
   Renders the gift line and the gift-only footer. Loads after
   ez-gift.js and reads window.EZGift for the rules.

   Additive. It wraps EZCart methods rather than editing
   ez-cart-drawer.js, so Shipping Protection, the shipping meter,
   upsells, Recharge grouping and the checkout form all keep
   their existing behaviour. Two wraps change outcomes, both only
   for a gift-only cart:

     ensureProtection  never auto-add protection to a cart that
                       holds nothing but a free tattoo, and clear
                       it if it is already there. The drawer's
                       own "real item" test is an inline
                       !isProt() repeated at six call sites, so
                       wrapping the method is far less invasive
                       than editing all six.
     renderProtection  hide the toggle row in the same state.

   The Checkout button is REMOVED from the footer in the
   gift-only state, not hidden. The node itself is kept and put
   back, because ez-cart-drawer.js warns that replacing that node
   makes a tap vanish; detaching happens on a cart change, never
   mid-tap.
   ============================================================ */
(function () {
  'use strict';

  var G = window.EZGift;
  if (!G) return;
  var CFG = G.config || {};

  /* ------------------------------------------------- money */
  /* Derived from an amount put through Liquid's money filter at
     render, so the struck-through price is right in all four
     markets rather than assuming an AUD format. */
  var fmt = (function (sample) {
    if (typeof sample !== 'string') return null;
    var m = sample.trim().match(/^([^0-9]*)([0-9][0-9., ’' ]*[0-9]|[0-9])([^0-9]*)$/);
    if (!m) return null;
    var body = m[2];
    var seps = body.replace(/[0-9]/g, '');
    var dec = seps.length ? seps.slice(-1) : '';
    var thou = seps.length > 1 ? seps.slice(-2, -1) : '';
    var decimals = 0;
    if (dec) {
      var tail = body.split(dec).pop();
      if (/^[0-9]+$/.test(tail)) decimals = tail.length;
    }
    if (decimals === 3) { thou = dec; dec = ''; decimals = 0; }
    return { prefix: m[1], suffix: m[3], dec: dec, thou: thou, decimals: decimals };
  })(CFG.moneySample);

  function money(cents) {
    if (!fmt) return (Math.abs(cents) / 100).toFixed(2);
    var out = (Math.abs(cents) / 100).toFixed(fmt.decimals).split('.');
    if (fmt.thou) out[0] = out[0].replace(/\B(?=([0-9]{3})+(?![0-9]))/g, fmt.thou);
    var body = out.length > 1 ? out[0] + (fmt.dec || '.') + out[1] : out[0];
    return fmt.prefix + body + fmt.suffix;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function sized(url, w) {
    if (!url) return '';
    return String(url).replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  /* ------------------------------------------- the gift line */
  /* The row keeps its <li> and its data-ez-line key; only the
     contents are replaced. No quantity stepper and no remove
     button: a gift a shopper can decrement to zero is a gift
     they can lose by accident. */
  function paintGiftRow(cart) {
    var list = document.querySelector('[data-ez-items]');
    if (!list || !cart) return;

    (cart.items || []).forEach(function (li) {
      if (!G.isGiftVariant(li)) return;

      var row = list.querySelector('[data-ez-line="' + li.key + '"]');
      if (!row) return;

      /* Not verified as a real gift: leave the drawer's own paid
         line exactly as it rendered it. */
      if (!G.isGift(li, cart)) return;
      if (row.classList.contains('ez-gift-row')) return;   // already ours

      var media = li.image
        ? '<div class="ez-gift-row__media"><img src="' + esc(sized(li.image, 160)) +
          '" alt="" width="56" height="56"></div>'
        : '<div class="ez-gift-row__media"></div>';

      row.className = 'ez-item ez-gift-row';
      row.innerHTML =
        media +
        '<div class="ez-gift-row__info">' +
          '<span class="ez-gift-row__title">' + esc(li.product_title) + '</span>' +
          '<span class="ez-gift-row__sub">' + esc(CFG.subtitle || 'Your welcome gift, added automatically') + '</span>' +
          '<span class="ez-gift-row__price">' +
            '<del>' + esc(money(li.original_line_price)) + '</del>' +
            '<span class="ez-gift-row__free">Free</span>' +
          '</span>' +
        '</div>';
    });
  }

  /* --------------------------------------- gift-only footer */
  var stash = null, stashParent = null, stashNext = null;

  function paintFooter(cart) {
    var foot = document.querySelector('[data-ez-foot]');
    if (!foot) return;

    var only = G.isGiftOnly(cart);
    var btn = foot.querySelector('.ez-checkout');
    var cta = foot.querySelector('[data-ez-gift-cta]');
    var note = foot.querySelector('[data-ez-gift-note]');

    if (only) {
      if (btn) {
        stash = btn;
        stashParent = btn.parentNode;
        stashNext = btn.nextSibling;
        stashParent.removeChild(btn);
      }
      if (!cta && stashParent) {
        cta = document.createElement('a');
        cta.className = 'ez-gift-cta button-secondary';
        cta.setAttribute('data-ez-gift-cta', '');
        cta.href = CFG.shopUrl || '/collections/all-tattoos';
        cta.textContent = CFG.shopLabel || 'Shop Tattoos';
        stashParent.insertBefore(cta, stashNext);

        note = document.createElement('p');
        note.className = 'ez-gift-note';
        note.setAttribute('data-ez-gift-note', '');
        note.textContent = CFG.note || 'Your gift is saved and travels with your order.';
        stashParent.insertBefore(note, cta.nextSibling);
      }
      return;
    }

    if (cta && cta.parentNode) cta.parentNode.removeChild(cta);
    if (note && note.parentNode) note.parentNode.removeChild(note);
    if (stash && !foot.contains(stash) && stashParent) {
      stashParent.insertBefore(stash, stashNext);
    }
  }

  /* ------------------------------------- upsell heading */
  /* Idempotent, and it uses its own attribute names so it never
     fights ez-bogo.js over the same node. The two can't both
     want it anyway: the gift is excluded from BOGO, so a
     gift-only cart has no eligible units. */
  function patchUpsellHead(cart) {
    var head = document.querySelector('[data-ez-upsell-head]');
    if (!head) return;

    var text = head.textContent.trim();
    var patched = head.getAttribute('data-ez-gift-patched');
    var ours = patched !== null && patched === text;
    var base = ours ? (head.getAttribute('data-ez-gift-base') || '') : text;
    var want = CFG.upsellHeading || 'Pair your gift with';

    if (!G.isGiftOnly(cart)) {
      if (ours) {
        head.textContent = base;
        head.removeAttribute('data-ez-gift-patched');
        head.removeAttribute('data-ez-gift-base');
      }
      return;
    }

    head.setAttribute('data-ez-gift-base', base);
    head.textContent = want;
    head.setAttribute('data-ez-gift-patched', want);
  }

  /* ------------------------------------------------- paint */
  var painting = false;

  function paint() {
    if (painting) return;
    var cart = window.EZCart && window.EZCart.cart;
    if (!cart) return;

    painting = true;
    try {
      paintGiftRow(cart);
      paintFooter(cart);
      patchUpsellHead(cart);
    } catch (e) {
      if (window.console && console.warn) console.warn('[ez-gift-ui]', e);
    } finally {
      painting = false;
    }
  }

  var queued = false;

  /* setTimeout, deliberately NOT requestAnimationFrame.

     rAF does not fire while the tab is hidden or heavily
     throttled. Because `queued` is only cleared inside the
     callback, a single missed frame LATCHES the flag: every
     later schedule() returns early and the drawer never repaints
     again for the life of the page. That is exactly what this
     hit - the gift landed in the cart on page load but the row
     stayed a plain paid line, while a manual render() painted it
     correctly. A cart repaint is not an animation and has no
     business waiting for a frame. */
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; paint(); }, 0);
  }

  /* -------------------------------------------------- wraps */
  function after(obj, name) {
    var orig = obj[name];
    if (typeof orig !== 'function' || orig.__ezGift) return;
    function wrapped() {
      var out = orig.apply(this, arguments);
      if (out && typeof out.then === 'function') out.then(schedule, schedule);
      else schedule();
      return out;
    }
    wrapped.__ezGift = true;
    try { obj[name] = wrapped; } catch (e) {}
  }

  function boot() {
    var C = window.EZCart;
    if (!C) return false;

    after(C, 'render');
    after(C, 'renderItems');
    after(C, 'renderFooter');
    after(C, 'renderUpsells');
    after(C, 'open');

    if (!C.ensureProtection.__ezGift) {
      var origEnsure = C.ensureProtection;
      C.ensureProtection = function () {
        if (this.cart && G.isGiftOnly(this.cart)) {
          var line = this.protectionLine && this.protectionLine();
          if (line) this.changeLine(line.key, 0);
          return;
        }
        return origEnsure.apply(this, arguments);
      };
      C.ensureProtection.__ezGift = true;
    }

    if (!C.renderProtection.__ezGift) {
      var origRP = C.renderProtection;
      C.renderProtection = function (c) {
        var out = origRP.apply(this, arguments);
        if (this.n && this.n.prot && G.isGiftOnly(c)) this.n.prot.hidden = true;
        return out;
      };
      C.renderProtection.__ezGift = true;
    }

    var list = document.querySelector('[data-ez-items]');
    if (list && window.MutationObserver) {
      new MutationObserver(schedule).observe(list, { childList: true });
    }

    schedule();
    return true;
  }

  if (!boot()) {
    var tries = 0;
    var t = setInterval(function () {
      if (boot() || ++tries > 60) clearInterval(t);
    }, 100);
  }
})();
